//
//
//
//
//
//
//
//

import * as types from '../src/store/mutation-types'
// var VConsole = require('vconsole')
// 初始化
// var vConsole = new VConsole()

export default {
  name: 'app',
  data() {
    return {
      transitionName: ''
    }
  },
  watch: {
    $route(to, from) {
      if (from.name == 'liveDetail' && to.name == 'liveInteraction') {
        this.transitionName = 'slide-left'
      }
      if (to.name == 'liveDetail' && from.name == 'liveInteraction') {
        this.transitionName = 'slide-right'
      }
    }
  },
  mounted() {
    let view = {
      viewHeight: document.documentElement.clientHeight,
      viewWidth: document.documentElement.clientWidth
    }
    this.$store.commit(types.base.setView, view)
  }
}



// WEBPACK FOOTER //
// ./src/App.vue